var map = {
	"./app.js": 49638,
	"./dict.js": 79173,
	"./discount.js": 79643,
	"./errorLog.js": 26386,
	"./label.js": 1618,
	"./list.js": 85498,
	"./permission.js": 26042,
	"./quote.js": 82157,
	"./tagsView.js": 56941,
	"./user.js": 49416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52645;